import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC } from "react";
import NavigationSection from "@/components/NavigationSection";
import RadioLink from "@/components/RadioLink";
import { AllProjectConstructionTypes } from "@/consts/ArchitectureDetail";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import formatConstructionType from "@/utils/formatConstructionType";

interface Props {
  query: ArchitectureSearchQueryParameter;
  queryController: SearchQueryParameterController<ArchitectureSearchQueryParameter>;
}

const NavigationSectionConstructionType: FC<Props> = ({
  query: { construction_type },
  queryController,
}): JSX.Element => {
  return (
    <NavigationSection title={`工事種別`} defaultOpen={!!construction_type}>
      <ul className="text-sm space-y-4">
        <li>
          <RadioLink
            checked={construction_type === undefined}
            href={queryController.toPath({
              construction_type: null,
            })}
          >
            指定なし
          </RadioLink>
        </li>
        {AllProjectConstructionTypes.map((value) => {
          return (
            <li key={value}>
              <RadioLink
                checked={construction_type === value.toString()}
                href={queryController.toPath({
                  construction_type: value.toString(),
                })}
              >
                {formatConstructionType(value)}
              </RadioLink>
            </li>
          );
        })}
      </ul>
    </NavigationSection>
  );
};
export default NavigationSectionConstructionType;
